import { Role } from "@/router/_helper";

  const staff = {
    path: "/staff",
    name: "staff",
    component: () => import(/* webpackChunkName: "staff" */ "@/components/staff/StaffIndex.vue"),
    children: [
      { path: "view/:id", component: () => import(/* webpackChunkName: "staff" */ "@/components/staff/StaffView.vue"), name: "staffView", meta: { authorize: [Role.Admin, Role.ComplianceStaff], requiresAuth: true } },
      { path: "edit/:id", component: () => import(/* webpackChunkName: "staff" */ "@/components/staff/StaffEdit.vue"), name: "staffEdit", meta: { authorize: [Role.Admin, Role.ComplianceStaff], requiresAuth: true } },
      { path: "create", component: () => import(/* webpackChunkName: "staff" */ "@/components/staff/StaffCreate.vue"), name: "staffCreate", meta: { authorize: [Role.Admin, Role.ComplianceStaff], requiresAuth: true }}
    ],
    meta: { authorize: [Role.Admin, Role.ComplianceStaff], requiresAuth: true }
  };

export default staff;
    